import Goals from '~/pages/anatomy/goals/libs/components/Goals'
import { TPageProps } from '~/shared/types/commonTypes'

const GoalsAnatomy = ({ nextPagePath, pageId }: TPageProps) => (
  <Goals nextPagePath={nextPagePath} pageId={pageId} />
)

export default GoalsAnatomy
